import { render, staticRenderFns } from "./PortfolioPageCard.vue?vue&type=template&id=a5532348&scoped=true&"
import script from "./PortfolioPageCard.vue?vue&type=script&lang=js&"
export * from "./PortfolioPageCard.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioPageCard.vue?vue&type=style&index=0&id=a5532348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5532348",
  null
  
)

export default component.exports